import React, { useEffect, useState } from 'react';
import {BrowserRouter, Redirect, Route, Switch} from 'react-router-dom';
import { hot } from 'react-hot-loader/root';
import GlobalStyle from '@css/GlobalStyle';
import { withAdminAuth } from '@/api/AuthService';
import store, { useStoreActions, useStoreState } from '@/store';
import { StoreProvider, useStoreRehydrated } from 'easy-peasy';
import config from '@/config';
import * as Sentry from '@sentry/react';
import { useLocation } from 'react-router';
import FrameworkUpdateWatcher from '@/components/FrameworkUpdateWatcher';
import { Spinner } from '@/components/common';
import getAuthenticatedUser from '@/api/getAuthenticatedUser';
import BroadcastManager from '@/components/BroadcastManager';
import 'chart.js/auto';
import LoginScreen from '@/components/login/LoginScreen';
import 'react-datepicker/dist/react-datepicker.css';
import HomeTTD from '@/components/HomeTTD';
import AccountsContainer from '@/components/dashboard/AccountsContainer';

console.log('version: ', config.version);

const AppLoader = () => {
    const [ loading, _setLoading ] = useState<boolean>(false);

    const token = useStoreState(state => state.user.token);
    const logout = useStoreActions(actions => actions.logout);

    useEffect(() => {
        BroadcastManager.init();
        BroadcastManager.onMessage((ev) => {
            console.log('heard message ev: ', ev);
            const { token } = store.getState().user;

            if (token) {
                if (ev.data === 'logout') {
                    logout({emit: false});
                } else {
                    try {
                        const data = JSON.parse(ev.data);
                        const { studentInfo } = store.getState().student;

                        if (data.type === 'login' && data.studentId !== studentInfo?.studentId) {
                            logout({emit: false});
                        }

                    } catch (err) {

                    }
                }
            }

        });
        return () => {
            BroadcastManager.cleanup();
        };

    }, []);

    useEffect(() => {
        if (token) {
            getAuthenticatedUser();
        }
    }, [ token ]);

    if (loading) return null;
    return (
        <>
            <FrameworkUpdateWatcher/>

            <Switch>
                <Route path="/login" component={LoginScreen}/>
                <Route path="/accounts" component={withAdminAuth(AccountsContainer)}/>
                <Route path='/' component={withAdminAuth(HomeTTD)}/>



                <Redirect to={'/'}/>
            </Switch>
        </>

    );
};

const HydratedApp = () => {
    const isHydrated = useStoreRehydrated();

    return (
        isHydrated ?
            <BrowserRouter>
                <AppLoader/>
            </BrowserRouter>
            :
            <Spinner/>
    );
};

const App = () => (
    <Sentry.ErrorBoundary>
        <GlobalStyle/>
        <StoreProvider store={store}>
            <HydratedApp/>
        </StoreProvider>

    </Sentry.ErrorBoundary>
);

export default hot(App);
